<template>
  <div>
    <button
      v-if="!isLoggedIn"
      class="btn btn-order2"
      type="button"
      @click.stop="goToLogin"
    >
      <font-awesome-icon :icon="['fas', 'right-from-bracket']" />
      <span class="hide-in-small-devices">Se connecter</span>
    </button>

    <button
      v-else
      class="btn btn-order2"
      type="button"
      @click.stop="goToPersonalSpace"
    >
      <font-awesome-icon :icon="['fas', 'user']" />
      <span class="hide-in-small-devices">Mon Espace Personnel</span>
    </button>
  </div>
</template>

<script>
import { useRouter } from "vue-router/composables";
import { ref, onMounted, onBeforeUnmount } from "vue";
import { userState } from "@/utils/store";

export default {
  setup() {
    const isLoggedIn = ref(false);
    const router = useRouter();

    const refreshAuthState = () => {
      let storeLogged = false;
      try {
        if (userState && typeof userState.isLoggedIn === "function") {
          storeLogged = !!userState.isLoggedIn();
        }
      } catch (e) {
        storeLogged = false;
      }

      const access = localStorage.getItem("accessToken");
      const refresh = localStorage.getItem("refreshToken");
      isLoggedIn.value = storeLogged || !!(access || refresh);
    };

    const goToLogin = () => {
      router.push({ name: "connection" });
    };

    const goToPersonalSpace = () => {
      router.push({ name: "my-menus" });
    };

    const onFocus = () => refreshAuthState();
    const onVisibilityChange = () => {
      if (!document.hidden) refreshAuthState();
    };

    onMounted(() => {
      refreshAuthState();
      window.addEventListener("storage", refreshAuthState);
      window.addEventListener("focus", onFocus);
      document.addEventListener("visibilitychange", onVisibilityChange);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("storage", refreshAuthState);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    });

    return {
      isLoggedIn,
      goToLogin,
      goToPersonalSpace,
    };
  },
};
</script>

<style scoped>
.btn-order {
  color: white;
  background-color: #004c40;
  transition: 0.3s;
  font-family: "TangoSans";
}

.btn-order:hover {
  color: #004c40;
  background-color: white;
  border-color: #004c40;
}

.btn-order2 {
  color: white;
  background-color: rgb(133, 187, 47);
  transition: 0.3s;
  font-family: "TangoSans";
}

.btn-order2:hover {
  color: white;
  background-color: #004c40;
  border-color: #004c40;
}

@media (max-width: 992px) {
  .btn-order2 {
    font-size: 12px;
  }
}

@media (max-width: 400px) {
  .hide-in-small-devices {
    display: none;
  }
}
</style>
